module.exports = __webpack_public_path__ + "static/img/douIcon.30117e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brandLanshu/douIcon.png
// module id = 3fCG
// module chunks = 0